//#region src/components/RRule/timeline-range.ts
var MINUTES_PER_DAY = 1440;
function snapMinutes(min) {
	return (Math.round(min / 30) * 30 % MINUTES_PER_DAY + MINUTES_PER_DAY) % MINUTES_PER_DAY;
}
function minutesToPercent(min) {
	return min / MINUTES_PER_DAY * 100;
}
function selectedSegments(fromMin, toMin, durationMin) {
	if (durationMin >= 1440) return [{
		end: MINUTES_PER_DAY,
		start: 0
	}];
	if (fromMin < toMin) return [{
		end: toMin,
		start: fromMin
	}];
	return [{
		end: MINUTES_PER_DAY,
		start: fromMin
	}, {
		end: toMin,
		start: 0
	}];
}
function minutesFromClientX(clientX, rect) {
	if (rect.width <= 0) return 0;
	return snapMinutes(Math.min(1, Math.max(0, (clientX - rect.left) / rect.width)) * MINUTES_PER_DAY);
}
function clockFromMinutes(min) {
	return {
		hour: Math.floor(min / 60),
		minute: min % 60
	};
}
function minutesFromClock(hour, minute) {
	return hour * 60 + minute;
}
function stepMinutes(min, delta) {
	return snapMinutes(min + delta);
}
//#endregion
export { MINUTES_PER_DAY, clockFromMinutes, minutesFromClientX, minutesFromClock, minutesToPercent, selectedSegments, snapMinutes, stepMinutes };

//# sourceMappingURL=timeline-range.js.map